import res from './res'

res.add('en', {
    title: 'Заявка на подключение к интернет-эквайрингу EPAY',
    buttons: {
        download: 'Скачать заявку'
    },
    labels: {
        bin: 'БИН/ИНН',
        bin_placeholder: '012345678901',
        check: 'Проверить',
        city: 'В каком городе обслуживаетесь',
        contact_faces: 'Контактные лица',
        full_name: 'ФИО',
        emails: 'Email:',
        continue: 'Сохранить и продолжить',
        back: 'Вернуться назад',
        finish: 'Завершить',
        description: 'Описание интернет-магазина',
        url: 'Ссылка на сайт интернет магазина или моб. приложения',
        shop_name: 'Наименование интернет-магазина',
        establishment_date: 'Магазин открыт более 6 месяцев?',
        shop_description: 'Описание товаров/услуг, реализуемых (предполагаемых к реализации) через Интернет-магазин',
        name: 'Имя',
        surname: 'Фамилия',
        middlename: 'Отчество',
        phone: 'Телефон'
    },
    subtitles: {
        service_bank: 'Банк обслуживания',
        tariff: 'Выберите тариф'
    },
    messages: {
        required: 'Обязательно',
        notFoundTitle: 'БИН не найден в базе налоговой РК',
        notFoundDescription: 'Проверьте правильность написания БИН.',
        warningRequires: 'Пожалуйста заполните обязательные поля.',
        validateFile: 'Пожалуйста загрузите в формате PDF',
        validateFileSize: 'Файл должен быть меньше 2МБ'
    },
    documents: {
        stateRegister: 'Cвидетельства о государственной регистрации / талон о приёме',
        statute: 'Устав с отметкой органа юстиции о регистрации, документ, подтверждающий юридический адрес',
        decision: 'Решение о назначении первого руководителя/директора',
        identityCardAccountant: 'Удостоверение личности / копия паспорта бухгалетра (При наличии, в формате PDF)',
        identityCardLeader: 'Удостоверение личности первого руководителя (В формате PDF)',
        requisites: 'Реквизиты банковского счета',
        leaderSignatureToo: 'Карточка с подписью руководителя (Если в карточке указано нескольно людей необходимо прикладывать их удостоверение личности и доверенность на право подписи)',
        leaderSignatureIp: 'Карточка с подписью руководителя (Если в карточке указано нескольно людей необходимо прикладывать их удостоверение личности и доверенность на право подписи)',
        constituentDocuments: 'Учредительные документы (Учредительный договор)',
        powerOfAttorney: 'Доверенность на подписанта (При наличии)',
        licensePaymentServices: 'Копия лицензии на платёжные услуги / Учётная регистрация'
    },
    tooltips: {
        stateRegister: 'Cвидетельства о государственной регистрации / талон о приёме',
        statute: 'Устав с отметкой органа юстиции о регистрации, документ, подтверждающий юридический адрес',
        decision: 'Решение о назначении первого руководителя/директора',
        identityCardAccountant: 'Удостоверение личности / копия паспорта бухгалетра (При наличии, в формате PDF)',
        identityCardLeader: 'Удостоверение личности первого руководителя (В формате PDF)',
        requisites: 'Реквизиты банковского счета',
        leaderSignature: 'Карточка с подписью руководителя (Если в карточке указано нескольно людей необходимо прикладывать их удостоверение личности и доверенность на право подписи)',
        constituentDocuments: 'Учредительные документы (Учредительный договор)',
        powerOfAttorney: 'Доверенность на подписанта (При наличии)',
        licensePaymentServices: 'Копия лицензии на платёжные услуги / Учётная регистрация'
    }
})
